import { useState } from "react";
import { faqList } from "@/mocks/home";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqList.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            关于韩漫在线，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqList.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 text-sm font-medium text-foreground-900 md:text-base">
                    <i
                      className={`text-primary-600 ${
                        isOpen ? "ri-question-answer-fill" : "ri-question-fill"
                      }`}
                    ></i>
                    {item.q}
                  </span>
                  <i
                    className={`text-lg text-foreground-500 transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    } ri-arrow-down-s-line`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 pl-12">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}